import { CONVERSIONS_OPTIONS } from '@/constants/call-tracking/destination/destinationConversionOptions'
import { TYPE_NUMBER } from '@/constants/call-tracking/campaign/typeNumber'
import { FILTERS_TABLE } from '@/constants/filtersTable'
import { REQUEST_STATUSES } from '@/constants/call-tracking/campaign/offer/requestStatuses'

const FILTER_STATUS = {
    label: 'Status',
    key: 'status_id',
    type: FILTERS_TABLE.list,
    values: [
        {
            id: 1,
            name: 'Active',
        },
        {
            id: 2,
            name: 'Paused',
        },
    ],
}

const FILTER_PURCHASE_STATUS = {
    label: 'Purchase status',
    key: 'provider_order_status',
    type: FILTERS_TABLE.list,
    values: [
        {
            id: 'pending',
            name: 'Pending',
        },
        {
            id: 'success',
            name: 'Success',
        },
        {
            id: 'failure',
            name: 'Failure',
        },
        {
            id: 'cancelled',
            name: 'Cancelled',
        },
        {
            id: 'deleted',
            name: 'Deleted',
        },
    ],
}

const FILTER_TYPE_NUMBER = {
    label: 'Type',
    key: 'type',
    type: FILTERS_TABLE.list,
    values: [
        {
            id: TYPE_NUMBER.STATIC,
            name: 'Static',
        },
        {
            id: TYPE_NUMBER.DYNAMIC,
            name: 'Dynamic',
        },
    ],
}

const FILTER_STATUS_CUSTOM = {
    ...FILTER_STATUS,
    custom: true,
}

const FILTER_ACTIVE = {
    label: 'Status',
    key: 'active',
    type: FILTERS_TABLE.list,
    values: [
        {
            id: 1,
            name: 'Active',
        },
        {
            id: 2,
            name: 'Paused',
        },
    ],
}

const FILTER_ROLE = {
    label: 'Role',
    key: 'role',
    type: 'list',
    values: [],
}

const FILTER_NAME = {
    label: 'Name',
    key: 'name',
    type: FILTERS_TABLE.string,
    values: [],
}

const FILTER_INVITE_STATUS = {
    label: 'Status',
    key: 'accepted',
    type: FILTERS_TABLE.boolean,
    values: [
        {
            label: 'Registered',
            value: 1,
        },
        {
            label: 'Pending',
            value: 0,
        },
    ],
}

const FILTER_URL_PARAM = {
    label: 'Url param',
    key: 'url_param',
    type: FILTERS_TABLE.string,
    values: [],
}

const FILTER_EMAIL = {
    label: 'Email',
    key: 'email',
    type: FILTERS_TABLE.string,
    values: [],
}

const FILTER_BUYER = {
    label: 'Buyer',
    key: 'buyer.id',
    type: FILTERS_TABLE.list,
    values: [],
}

const FILTER_DESTINATION = {
    label: 'Destination',
    key: 'destination',
    type: FILTERS_TABLE.string,
    values: [],
}

const FILTER_TYPE_DESTINATION = {
    label: 'Type',
    key: 'pivot.convert_on_id',
    type: FILTERS_TABLE.list,
    values: [
        {
            id: CONVERSIONS_OPTIONS.converted.id,
            name: CONVERSIONS_OPTIONS.converted.name,
        },
        {
            id: CONVERSIONS_OPTIONS.length.id,
            name: CONVERSIONS_OPTIONS.length.name,
        },
        // {
        //     id: CONVERSIONS_OPTIONS.webhooks.id,
        //     name: CONVERSIONS_OPTIONS.webhooks.name,
        // },
    ],
}

const FILTER_REVENUE_DESTINATION = {
    label: 'Revenue',
    key: 'pivot.revenue',
    type: FILTERS_TABLE.number,
    values: [],
}

const FILTER_NUMBER_POOL_TRACKING_NUMBER = {
    label: 'Number pool',
    key: 'slave_pool.slug',
    type: FILTERS_TABLE.list,
    values: [],
}

const FILTER_VENDOR_TRACKING_NUMBER = {
    label: 'Vendor',
    key: 'vendor.slug',
    type: FILTERS_TABLE.list,
    values: [],
}

const FILTER_VENDOR = {
    label: 'Vendor',
    key: 'vendor.slug',
    type: FILTERS_TABLE.list,
    values: [],
}

const FILTER_VENDOR_EMAIL = {
    label: 'Vendor email',
    key: 'vendor_email',
    type: FILTERS_TABLE.string,
    values: [],
}

const FILTER_REVIEWED_BY = {
    label: 'Reviewed by',
    key: 'reviewerFullName',
    type: FILTERS_TABLE.string,
    values: [],
}

const FILTER_REQUEST_STATUS = {
    label: 'Status',
    key: 'status_id',
    type: FILTERS_TABLE.list,
    values: Object.values(REQUEST_STATUSES),
}

const FILTER_TRAFFIC_SOURCE_TRACKING_NUMBER = {
    label: 'Traffic source',
    key: 'traffic_source.slug',
    type: FILTERS_TABLE.list,
    values: [],
}

const FILTER_VENDOR_PAYOUT_TRACKING_NUMBER = {
    label: 'Payout',
    key: 'vendor.pivot.payout',
    type: FILTERS_TABLE.number,
    values: [],
}

export {
    FILTER_STATUS,
    FILTER_PURCHASE_STATUS,
    FILTER_TYPE_NUMBER,
    FILTER_STATUS_CUSTOM,
    FILTER_ACTIVE,
    FILTER_ROLE,
    FILTER_NAME,
    FILTER_INVITE_STATUS,
    FILTER_URL_PARAM,
    FILTER_EMAIL,
    FILTER_BUYER,
    FILTER_VENDOR,
    FILTER_DESTINATION,
    FILTER_TYPE_DESTINATION,
    FILTER_REVENUE_DESTINATION,
    FILTER_NUMBER_POOL_TRACKING_NUMBER,
    FILTER_VENDOR_TRACKING_NUMBER,
    FILTER_TRAFFIC_SOURCE_TRACKING_NUMBER,
    FILTER_VENDOR_PAYOUT_TRACKING_NUMBER,
    FILTER_VENDOR_EMAIL,
    FILTER_REVIEWED_BY,
    FILTER_REQUEST_STATUS,
}
